var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import ovoid from "@gouvfr/dsfr/dist/artwork/background/ovoid.svg";
var StateMessageBoxArtworkCommon = forwardRef(function (_a, ref) {
    var children = _a.children, color = _a.color, state = _a.state, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "color", "state", "className", "style"]);
    var classNameSvg = "fr-responsive-img fr-artwork";
    if (color) {
        classNameSvg += " fr-artwork--".concat(color);
    }
    if (className) {
        classNameSvg += " ".concat(className);
    }
    var backgroundClassName = "fr-artwork-background";
    if (state) {
        backgroundClassName += " fr-artwork-background--".concat(state);
    }
    var motifClassName = "fr-artwork-motif";
    if (state) {
        motifClassName += " fr-artwork-motif--".concat(state);
    }
    return (React.createElement("svg", __assign({}, otherProps, { ref: ref, xmlns: "http://www.w3.org/2000/svg", className: classNameSvg, "aria-hidden": "true", width: "160", height: "200", viewBox: "0 0 160 200", style: style }),
        React.createElement("use", { className: backgroundClassName, href: "".concat(ovoid, "#artwork-background") }),
        React.createElement("use", { className: motifClassName, href: "".concat(ovoid, "#artwork-motif") }),
        React.createElement("g", { transform: "translate(40, 60)" }, children)));
});
export default StateMessageBoxArtworkCommon;
